










































import { Component, Vue, Prop } from 'nuxt-property-decorator';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import type { Step } from './types';
import MobileFixedFallback from '~/components/common/MobileFixedFallback/index.vue';

@Component({
  components: {
    MobileFixedFallback,
    LogoSvg: () => import('@/components/partials/onboarding-v3_1/images/logo.vue.svg'),
    ArrowRightIcon: () => import('@/components/partials/jobs/JobsCustomAction/images/arrow-right.vue.svg'),
    BackIconSvg: () => import('@/components/partials/onboarding-v3_1/images/back.vue.svg'),
    // FIXME: use REAL button instead, that's insane that we use div as button
    BravadoButtonV3,
  },
})
export default class Layout extends Vue {
  @Prop({ default: 'Next' }) buttonText!: string;
  @Prop() isFirstStep!: boolean;
  @Prop() isValid!: boolean;
  @Prop() step!: Step;

  get hideNextButton() {
    return this.step?.submitOnChange;
  }
}
